import React from "react";
import TextInput from "../../../../components/Input/TextInput";
import { Group } from "@mantine/core";

const TradeInDropdown = ({ form }) => {
  return (
    <Group>
      <TextInput label={"Trade In Allowance"} placeholder="Trade In Allowance" form={form} validateName="tradeIn" size="xs" />
      <TextInput label={"Trade In Payoff"} placeholder="Trade In Payoff" form={form} validateName="tradeInPayoff" size="xs" />
    </Group>
  );
};

export default TradeInDropdown;
